export const STORAGE_LANG_KEY = 'preferred_lang';

export const IMAGE_FORMATS = {
  SVG: 'svg',
  PNG: 'png',
  JPG: 'jpg',
  GIF: 'gif',
};
